(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsMailingGeneralController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'NotificationService', 'MailingCampaignService'];

  function reports ($scope, $http, $timeout, ngTableParams, NotificationService, MailingCampaignService) {
    var vmRMailingGeneral = this;

      $scope.vmRMailingGeneral = vmRMailingGeneral;

    vmRMailingGeneral.filters = {
      typeReport: 12,
      report: 'GeneralMailingReport',
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      campaign: '',
      status: ''
    };

    vmRMailingGeneral.reload = function () {
      delete vmRMailingGeneral.filters.sendByEmail;
      delete vmRMailingGeneral.filters.emailData;

      $http.post(apiUrl + '/reports/mailing/newCommonReport', {
        filters: vmRMailingGeneral.filters
      })
        .then(function ({ data, status, headers, config }) {
          if (status == 200) {
            NotificationService.successHandler(null, $scope.labels.requestProcessed);
            vmRMailingGeneral.download(data, headers)
          }

          if (status == 204) {
            NotificationService.warningHandler(null, $scope.labels.noRecordFound);
          }
        }, function ({ data, status, headers, config }) {
          if (status == 504) {
            vmRMailingGeneral.filters.sendByEmail = true;
            vmRMailingGeneral.filters.emailData = getEmailConfigs();

            $http.post(apiUrl + '/reports/mailing/newCommonReport', {
              filters: vmRMailingGeneral.filters
            })
              .then(function () {
                NotificationService.warningHandler(null, $scope.labels.alertProcessMail);
              }, function (error) { console.log(error) });

            return;
          }

          if (status == 400) {
            NotificationService.errorHandler(null, $scope.labels.alertProcessMail);
            return;
          }

          NotificationService.errorHandler(null, $scope.labels.errorLoadCamp);
        })
    };

    function getEmailConfigs () {
      return {
        reportTitle: $scope.labels.title,
        message: $scope.labels.title
      }
    }

    vmRMailingGeneral.download = (data, headers) => {
      var filename = headers('Mktzap-Filename') || 'GeneralMailingReport';

      var anchor = angular.element('<a/>');
      anchor.css({ display: 'none' });
      angular.element(document.body).append(anchor);

      var blob = new Blob([data], { type: 'text/csv' });
      var csvUrl = URL.createObjectURL(blob);

      anchor.attr({
        href: csvUrl,
        target: '_self',
        download: filename
      })[0].click();

      anchor.remove();
      URL.revokeObjectURL(csvUrl);
    }

    MailingCampaignService
      .getCampaigns()
      .$promise
      .then(function (obj) {
        vmRMailingGeneral.campaigns = obj;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $scope.labels.errorLoadCamp);
      });
  }
})();
